import { Component, ViewChild } from '@angular/core';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'lib-cs-summary-current-origin',
    templateUrl: './cs-summary-current-origin.component.html',
    styleUrl: './cs-summary-current-origin.component.css',
})
export class CsSummaryCurrentOriginComponent {
    public gridId = 143;
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Car Status Summary - Current by Fleet & Comm Class Report';
    public gridSource: any;
    @ViewChild('bdsReportGrid') dataGrid: DxDataGridComponent;

    constructor(public reportService: RailtracReportsService, public pageService: PageService) {}

    ngOnInit() {
        this.pageService.setHeader(this.pageHeader);
        this.gridSource = this.reportService.CreateAspNetDatastore(
            this.apiCall,
            this.gridId.toString(),
        );
    }
}
